import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

function LottieAnimation() {
  const containerRef = useRef(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: require("../../assets/animations/success.json"), 
    });
    return () => {
      animation.destroy();
    };
  }, []);

  return <div ref={containerRef}></div>;
}

export default LottieAnimation;
